<template>
	<div class="supplier-card">
		<div class="supplier-card__title">Карточка поставщика</div>
		<hr>
		<div class="info-list">
			<SupplierInfo :supplier="supplier" :show-product-groups="false"/>
			<div v-if="supplier" class="info-list__item">
				<ProductCategories
					title="Изменение товарных категорий"
					:authorized="false"
					:checkedProductGroups="supplier?.productGroups"
					v-model="formData.productGroups"/>
				<hr>
				<button class="btn btn--color" @click="ShowEditCategoriesConfirmPopup = true">Изменить</button>
			</div>
		</div>
		<hr>
		<div class="info-list__title page-subtitle">Уведомления</div>
		<div class="info-list">
			<div class="info-list__notify">
				<InputSwitch label="Email" v-model="notifyFormData.email"/>
				<InputSwitch label="Мессенджер" v-model="notifyFormData.messenger"/>
			</div>
			<hr>
			<button class="btn btn--color" @click="sendNotifySettings" :disabled="loading">Сохранить</button>
		</div>
		
	</div>
	<transition name="modal">
		<EditCategoriesConfirmPopup v-if="ShowEditCategoriesConfirmPopup" @close="ShowEditCategoriesConfirmPopup = false" @confirmChange="sendForm()"/>
	</transition>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import ProductCategories from "@/components/blocks/ProductCategories";
import EditCategoriesConfirmPopup from "@/components/sections/LcSupply/SupplierCard/EditCategoriesConfirmPopup.vue";
import objectToFormData from "@/utils/ObjectToFormData";
import Fetch from "@/utils/Fetch";
import { useToast } from "vue-toastification";
import SupplierInfo from '@/components/sections/Suppliers/SupplierInfo.vue';
import InputSwitch from "@/components/base/utils/formElements/InputSwitch.vue";

export default {
	name: "EditSupplierCard",
	components: {
		ProductCategories,
		EditCategoriesConfirmPopup,
		SupplierInfo,
		InputSwitch
	},
	data() {
		return {
			toast: useToast(),
			ShowEditCategoriesConfirmPopup: false,
			loading: false,
			formData: {
				productGroups: [],
			},
			notifyFormData: {
				email: false,
				messenger: false
			}
		}
	},
	async created() {
		await this.requestFullUserData();
		this.notifyFormData.email = this.supplier?.notifications?.byEmail
		this.notifyFormData.messenger = this.supplier?.notifications?.byMessenger
	},
	methods: {
		async sendForm() {
			const body = objectToFormData({
				productGroups: this.formData.productGroups,
			})

			let response = await Fetch('suppliers/change-groups/', {
				method: 'POST',
				body
			})
			

			if(response.success) {
				this.toast.success('Ваши товарные категории успешно изменены');
				this.requestMyManager();
			} else {
				this.toast.error(response.message);
			}
		},
		...mapActions({
			requestFullUserData: "user/requestFullUserData",
			requestMyManager: 'suppliers/requestMyManager',
		}),

		async sendNotifySettings() {
			this.loading = true
			const body = objectToFormData(this.notifyFormData)

			let response = await Fetch('suppliers/notifications/change/', {
				method: 'POST',
				body
			})
			

			if(response.success) {
				this.toast.success('Настройки уведомлений успешно изменены');
			} else {
				this.toast.error(response.message);
			}
			this.loading = false
		}
	},

	computed: {
		listProductControl() {
			return this.supplier?.productControl.map(element => element.name).join(', ')
		},
		...mapGetters({
			supplier: "user/getFullUserData",
		}),
	}
}

</script>